<template>
  <div class="loginContainer">
    <el-form :model="loginForm"
             :rules="fieldRules"
             ref="loginForm"
             label-position="left"
             label-width="0px"
             class="demo-ruleForm login-container">
      <h2 class="title">逍遥陪玩管理系统</h2>
      <el-form-item prop="account">
        <el-input type="text"
                  prefix-icon="el-icon-user"
                  v-model="loginForm.account"
                  auto-complete="off"
                  placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password"
                  prefix-icon="el-icon-lock"
                  v-model="loginForm.password"
                  auto-complete="off"
                  placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item style="width:100%;">
        <el-button type="primary"
                   style="width:48%;background-color: grey;border: 1px solid grey"
                   @click.native.prevent="reset">重 置</el-button>
        <el-button type="primary"
                   style="width:48%;"
                   @click.native.prevent="login"
                   native-type="submit"
                   :loading="loading">登 录</el-button>
      </el-form-item>
    </el-form>

    <div class="icpCss">Copyright 2025-{{this.year}}  [逍遥陪玩管理系统]归深圳市逍遥软件科技有限公司版权所有</div>
    <div class="icpCss"
         style="bottom: 30px"><a href="https://beian.miit.gov.cn"
         target="_blank"
         style="color: black">粤ICP备2021002655号-2</a>
        </div>
    <div class="icpCss" style="bottom: 10px">深圳市逍遥软件科技有限公司提供技术支持</div>
  </div>

</template>

<script>
import { mapState } from 'vuex'
import Cookies from "js-cookie"
import ThemePicker from "@/components/ThemePicker"
import LangSelector from "@/components/LangSelector"
export default {
  name: 'Login',
  components: {
    ThemePicker,
    LangSelector
  },
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback()
      }
    };
    return {
      loading: false,
      year: '2023',
      size: 'small',
      loginForm: {
        account: '',
        password: '',
      },
      fieldRules: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { validator: validatePass, trigger: 'blur' }
        ]
      },
      checked: true,
    }
  },
  methods: {
    enterLogin () {
      document.onkeydown = (e) => {
        if (this.$router.path == '/login' && (e.code == 'Enter' || e.code == 'enter')) {
          this.login()
        }
      }
    },
    login () {
      if (this.loginForm.account.length <= 0 || this.loginForm.password.length <= 0) {
        return false
      }

      this.loading = true
      let userInfo = { account: this.loginForm.account, password: this.loginForm.password }

      this.$api.login.login(userInfo).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: '登录成功',
            type: 'success'
          })

          //Cookies.set('token', res.data.token, 2) // 放置token到Cookie
          sessionStorage.setItem('token', res.data.token) // 放置token到Cookie
          Cookies.set('user', res.data.sysUser.nickName, 2) // 放置token到Cookie
          Cookies.set('name', userInfo.account, 2) // 放置token到Cookie
          Cookies.set('merchantId', res.data.sysUser.merchantId, 2) // 放置token到Cookie
          sessionStorage.setItem('user', userInfo.account) // 放置token到Cookie
          sessionStorage.setItem('nickName', res.data.sysUser.nickName) // 放置token到Cookie

          this.$store.commit('menuRouteLoaded', false) // 要求重新加载导航菜单
          this.$router.push('/')  // 登录成功，跳转到主页
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
        this.loading = false
      }).catch((res) => {
        this.$message({
          message: res.msg,
          type: 'error'
        })
        this.loading = false
      });
    },
    reset () {
      this.$refs.loginForm.resetFields()
    },
    // 切换主题
    onThemeChange: function (themeColor) {
      this.$store.commit('setThemeColor', themeColor)
    },
    getDate () {
      let nowDate = new Date()
      this.year = nowDate.getFullYear()
    }
  },
  mounted () {
    this.getDate()
  },
  created () {
    this.enterLogin()
  },
  computed: {
    ...mapState({
      themeColor: state => state.app.themeColor
    })
  }
}
</script>


<style lang="scss">
a {
  text-decoration: none;
}
.loginContainer {
  .el-dialog__header {
    padding: 0px;
  }
  .el-dialog__body {
    padding: 10px;
  }
  .el-dialog {
    margin-top: 120px !important;
  }
  .el-input {
    .el-input__prefix {
      left: 0;
      width: 48px;
    }
    .el-input__inner {
      padding-left: 60px;
    }
    .el-input__prefix::after {
      content: "";
      width: 1px;
      height: 18px;
      background-color: #b8b8b8;
      position: absolute;
      right: 0;
      top: 10px;
    }
  }
}
</style>
<style lang="scss" scoped>
input {
  outline: none;
}
.loginContainer {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: url(../assets/background2.jpg) no-repeat;
  background-size: 100% 100%;
}
.login-container {
  position: relative;
  width: 350px;
  margin: 180px auto;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  padding: 35px 35px 15px 35px;
  /*background: #91dcffa1;*/
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
  .title {
    margin: 0px auto 50px auto;
    text-align: center;
    color: #505458;
  }
  .remember {
    margin: 0px 0px 35px 0px;
  }
  .links {
    height: 30px;
    line-height: 30px;
    text-align: right;
    font-size: 14px;
    margin-bottom: 15px;
    label {
      text-decoration: none;
      color: #333;
      cursor: pointer;
    }
  }
}
.btnColor {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}
.mark {
  position: absolute;
  bottom: 20px;
  font-size: 12px;
  color: #666;
  left: 50%;
  transform: translateX(-50%);
}
.icpCss {
  width: 100%;
  position: fixed;
  bottom: 50px;
  font-size: 12px;
  color: black;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue